import React, {useEffect, useState} from "react";
import {FormComponent, FormSectionComponent, FormSubmitSectionComponent, InputComponent} from "@Components/Forms";
import {SectionContainerComponent} from "@Components/Sections";
import "./index.scss";

import {InputComponentStatusType} from "@Components/Forms/Inputs/Input/types";
import isEmail from "validator/lib/isEmail";
import ApplicationStore, {AuthenticationActionsTypes} from "@Store";
import {UseUserSignInAction} from "@Store/@Hooks/@@Actions";


export const SignInPageFormComponent:React.FC = () => {


    const UserSignInAction = UseUserSignInAction();


    const [userEmailAddress, setUserEmailAddress] = useState('');
    const [userPassword, setUserPassword] = useState('');

    const [userEmailAddressState, setUserEmailAddressState] = useState<InputComponentStatusType | null>(null);
    const [userPasswordState, setUserPasswordState] = useState<InputComponentStatusType | null>(null);


    useEffect(() => {
        return () => {
            setUserEmailAddress('');
            setUserPassword('');
            setUserEmailAddressState(null);
            setUserPasswordState(null);
        }
    }, []);


    const changeUserEmailAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
        const userEmailAddress = e.target.value;
        if (isEmail(userEmailAddress) && userEmailAddressState?.type === 'error') {
            setUserEmailAddressState({ type: 'success' });
        }
        setUserEmailAddress(userEmailAddress);
    };

    const changeUserPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        const userPassword = e.target.value;
        if (userPassword.length > 7 && userPasswordState?.type === 'error') {
            setUserPasswordState({ type: 'success' });
        }
        setUserPassword(userPassword);
    };


    const signInFormSubmitHandler = () => {

        let formErrors = false;

        if (!isEmail(userEmailAddress)) {
            formErrors = true;
            setUserEmailAddressState({ type: 'error', message: 'Email is invalid' });
        }

        // if (userPassword !== 'Qyvo2025') {
        //     formErrors = true;
        //     setUserPasswordState({ type: 'error', message: 'Password is invalid' });
        // }

        if (formErrors) {
            return;
        }

        signInFormRequestHandler();

    };

    const signInFormRequestHandler = async () => {

        const formData = new FormData();
        formData.append('qyvo_user_email', userEmailAddress);
        formData.append('qyvo_user_password', userPassword);

        try {
            const response = await fetch(
                `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/qyvo-user-sign-in/`,
                { method: 'POST', body: formData }
            );
            if (response.ok) {
                const responseData = await response.json();
                UserSignInAction({
                    qyvoUserID: responseData.qyvo_user_id,
                    qyvoUserEmail: userEmailAddress,
                });
            } else {
                setUserEmailAddressState({ type: 'error', message: 'Email Address not registered' });
            }
        } catch (e) {
            setUserEmailAddressState({ type: 'error', message: 'Something went wrong, try again' });
        }

    };


    return (
        <SectionContainerComponent
            id={'sign-in-page__sign-in-form'}
            sectionType={'main'}
        >

            <FormComponent
                xl={6}
            >

                <FormSectionComponent
                    sectionHeaderText={'Sign In'}
                >

                    <InputComponent
                        value={userEmailAddress}
                        setValue={(e) => changeUserEmailAddress(e)}
                        type={'email'}
                        label={'Email Address'}
                        status={userEmailAddressState}
                    />

                    <InputComponent
                        value={userPassword}
                        setValue={(e) => changeUserPassword(e)}
                        type={'password'}
                        label={'Password'}
                        status={userPasswordState}
                    />

                </FormSectionComponent>

                <FormSubmitSectionComponent
                    buttonText={'Sign In'}
                    buttonCallback={signInFormSubmitHandler}
                >

                </FormSubmitSectionComponent>

            </FormComponent>

        </SectionContainerComponent>
    );

};


export default SignInPageFormComponent;
